import * as api from '../../../api'

export default {
  namespaced: true,
  state: {
    salons: [],
    popularServices: {},
    services: {},
    masters: {},
    serviceMasters: [],
    isLoading: false
  },

  getters: {
    getPopularServices: (state) => (salonId) => state.popularServices[salonId],
    getSalonServices: (state) => (salonId) => state.services[salonId],
    getSalonMasters: (state) => (salonId) => state.masters[salonId],
    // getSalonServiceMasters: (state) => (salonId, serviceId) => state.masters[salonId][serviceId],

    getSalon: (state) => (salonId) => state.salons.find(salon => salon.id === salonId),

    getMaster: (state, getters) => (salonId, masterId) => {
      const salonMasters = getters.getSalonMasters(salonId)
      return salonMasters ? salonMasters.find(service => service.id === masterId) : null
    },

    getServiceMasters: (state) => state.serviceMasters,

    getService: (state, getters) => (salonId, serviceId) => {
      const salonServices = getters.getSalonServices(salonId)
      return salonServices ? salonServices.find(service => service.id === serviceId) : null
    },

    getSubService: (state, getters) => (salonId, serviceId, subServiceId) => {
      const currentService = getters.getService(salonId, serviceId)
      if (subServiceId == -1)
        return currentService;
      return currentService ? currentService.subcat.filter(e => e != null).find(service => service.id === subServiceId) : null
    },

    getConcreteService: (state, getters) => (salonId, serviceId, subServiceId, concreteServiceId, levelId = null) => {
      const subService = getters.getSubService(salonId, serviceId, subServiceId)
      const concreteService = subService ? subService.services.find(subService => subService.id === concreteServiceId) : null
      if (concreteService && levelId) {
        return concreteService.levels.find(e => e.id === levelId)
      }
      return subService ? subService.services.find(subService => subService.id === concreteServiceId) : null
    },
    getUniqueMetroStations: (state) => {
      let getUnique = (arr, comp) => {
        return arr
          .map(e => e[comp])
          .map((e, i, final) => final.indexOf(e) === i && i)
          .filter(e => arr[e]).map(e => arr[e]);
      }
      return getUnique(state.salons, 'metro');
    }
  },

  actions: {
    async fetchSalon({
      dispatch,
      commit,
      state
    }, {
      salonId,
      gender
    }) {
      // check that salon data already loaded
      // if (!state.services[salonId]) {
      await dispatch('fetchSalonServices', {
        salonId,
        gender
      })
      // }
    },

    async fetchSalons({
      state,
      commit
    }) {
      const { salons } = state
      // check that salons already loaded
      // if (!Array.isArray(salons) || !salons.length) {
      try {
        let res = await api.getSalons()
        commit('setSalons', res)
      } catch (e) {
        console.log('fetchSalons: ', e)
      }
      // }
    },

    async fetchSalonPopularServices({
      commit
    }, salonId) {
      commit('setPopularServices', {
        salonId,
        popularServices: await api.getSalonPopularServices(salonId)
      })
    },

    async fetchSalonServices({
      commit
    }, {
      salonId,
      gender
    }) {
      commit('setServices', {
        salonId,
        services: await api.getSalonServices(salonId, gender)
      })
    },

    async fetchSalonMasters({
      commit
    }, salonId) {
      commit('setMasters', {
        salonId,
        masters: await api.getSalonMasters(salonId)
      })
    },

    async fetchSalonServiceMasters({
      commit,
      rootState
    }, {
      salonId,
      date
    }) {
      let gender = rootState.client.customer.gender;
      let serviceId = rootState.client.serviceInProgress.concreteServiceId;
      let serviceLevelId = rootState.client.serviceInProgress.concreteServiceLevelId;
      commit('setServiceMasters', {
        masters: undefined
      })
      commit('setServiceMasters', {
        masters: await api.getSalonServiceMasters(salonId, serviceId, serviceLevelId, gender, date)
      })
    },

    async fetchMasterAvailableTime(context, {
      masterId,
      date,
      serviceId,
      serviceLevelId,
      options
    }) {
      return await api.getMasterAvailableTime(masterId, date, serviceId, serviceLevelId, options)
    },

    async fetchMasterWorkingTime(context, {
      masterId
    }) {
      return await api.getMasterWorkingTime(masterId)
    },
  },

  mutations: {
    setCurrentSalonId(state, currentSalonId) {
      state.currentSalonId = currentSalonId
    },
    setSalons(state, salons) {
      state.salons = salons
      // state.services = []
      state.mastesr = []
      state.serviceMasters = []
    },
    setPopularServices(state, {
      salonId,
      popularServices
    }) {
      state.popularServices[salonId] = popularServices
    },
    setServices(state, {
      salonId,
      services
    }) {
      state.services[salonId] = services
      const temp = Object.assign({}, state.services)
      state.services = Object.assign({}, temp)
    },
    setMasters(state, {
      salonId,
      masters
    }) {
      state.masters[salonId] = masters
    },
    setServiceMasters(state, {
      masters
    }) {
      state.serviceMasters = masters
    }
  }
}
